import { State } from '../state';

export const AlarmSuggestionSelectors = {
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
AlarmSuggestionAcceptReject: (state: State) => state.AlarmSuggestion,
 };
